import { Phone, MapPin } from "lucide-react";
import { SITE, NAV } from "@/lib/site";

export default function Footer() {
  const handleNav = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="site-footer" className="bg-[#012a2d] text-[#fcf3e6] border-t border-[#fcf3e6]/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 pt-20 pb-10">
        <div className="text-center">
          <div className="text-[#048a93] uppercase text-[11px] tracking-[0.32em] font-semibold mb-5">Motto</div>
          <p className="font-serif-display italic text-3xl sm:text-4xl lg:text-6xl font-light leading-tight">
            Relaxare. <span className="text-[#048a93] not-italic font-medium">Distracție.</span><br className="hidden sm:block" /> Amintiri frumoase.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-10 items-start">
          <div className="md:text-left">
            <img src={SITE.logo} alt="AriDanya" className="h-24 w-auto object-contain bg-[#fcf3e6] rounded-2xl p-2" />
            <p className="mt-4 font-sans-ui text-[#fcf3e6]/60 text-sm leading-relaxed max-w-xs">
              Locație de evenimente cu piscină, în Giulești. Petreceri private, aniversări și momente de neuitat.
            </p>
          </div>

          <div className="md:text-center">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#048a93] font-semibold mb-4">Navigare</div>
            <ul className="space-y-2 font-serif-display text-lg">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => handleNav(n.id)}
                    className="hover:text-[#048a93] transition-colors"
                    data-testid={`footer-nav-${n.id}`}
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:text-right">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#048a93] font-semibold mb-4">Contact</div>
            <a href={SITE.phoneHref} className="inline-flex md:justify-end items-center gap-3 font-serif-display text-xl hover:text-[#048a93] transition" data-testid="footer-phone">
              <Phone className="h-4 w-4 text-[#048a93]" /> {SITE.phoneDisplay}
            </a>
            <div className="mt-3 inline-flex md:justify-end items-center gap-3 font-serif-display text-xl">
              <MapPin className="h-4 w-4 text-[#048a93]" /> {SITE.location}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#fcf3e6]/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#fcf3e6]/40 font-sans-ui">
          <div>© {new Date().getFullYear()} AriDanya Garden · Pool & Lounge. Toate drepturile rezervate.</div>
          <div>Făcut cu grijă pentru amintiri frumoase.</div>
        </div>
      </div>
    </footer>
  );
}
